export default {
  faq: [
    {
      minhaCasaMinhaVida: [
        {
          id: 1,
          title: 'O que é?',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 1,
              title: 'O que é o programa Minha Casa Minha Vida?',
              url: 'o-que-e-programa-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer saber o que é o Programa Minha Casa Minha Vida? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre Minha Casa Minha Vida!',
              content: `
            <p>O MCMV é um programa criado pelo Governo Federal em 2009 para ajudar famílias a alcançarem o sonho da casa própria, facilitando o financiamento dos imóveis. Esse trabalho é feito em parceria com governos municipais, estaduais e empresas como a gente.</p>
            <p>Criado pra tornar possível esse sonho de tantas pessoas, o programa é muito acessível e tem vantagens únicas. Clique <a href='/duvidas-frequentes/vantagens-do-programa-mcmv'>aqui</a> e saiba mais sobre os benefícios de financiar seu futuro lar com o Minha Casa Minha Vida.</p>
          `,
            },
            {
              id: 2,
              title: 'Quais as vantagens do programa Minha Casa Minha Vida?',
              url: 'vantagens-do-programa-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Saiba quais são as vantagens em contratar o Programa Minha Casa Minha Vida. Acesse o site e confira essa e outras dúvidas sobre Minha Casa Minha Vida!',
              content: `
            <p>O Minha Casa Minha Vida tem muitos benefícios que já ajudaram milhões de brasileiros a realizarem o sonho da casa própria. Confira os principais deles:</p>
            <ul>
                <li>Você pode contar com o <strong>subsídio</strong>: um “empurrãozinho” que o Governo te dá. Uma parte do valor do seu imóvel é paga por ele, descontando diretamente do preço total. Quer entender melhor o que é subsídio? Clique <a href='/duvidas-frequentes/o-que-e-subsidio-e-como-e-calculado'>aqui</a>.</li>
                <li>As <strong>taxas de juros</strong> são as menores do mercado, bem baixas mesmo. Saiba mais sobre os juros <a href='/duvidas-frequentes/como-sao-calculados-juros-mcmv'>nessa página</a>.</li>
                <li>O Minha Casa Minha Vida tem o <strong>maior prazo de financiamento</strong> do mercado, que pode chegar até a 360 meses, ou seja: você pode parcelar em até 30 anos! Para saber mais sobre o parcelamento, <a href='https://www.meuvivaz.com.br/duvidas-frequentes/numero-de-parcelas-maximas-mcmv'>clique aqui</a>.</li>
                <li>Você pode usar seu <strong>FGTS</strong> no Minha Casa Minha Vida! O dinheiro do Fundo de Garantia por Tempo de Serviço pode ser utilizado na entrada do financiamento, na quitação das parcelas ou na redução do seu saldo devedor. Para saber as regras da utilização do FGTS, é só <a href='/duvidas-frequentes/numero-de-parcelas-maximas-mcmv'>clicar aqui</a>.</li>
          </ul>
          `,
            },
            {
              id: 3,
              title: 'Qual a diferença entre COHAB, CDHU e Minha Casa Minha Vida?',
              url: 'diferenca-cohab-cdhu-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Não sabe quais são as diferenças entre COHAB, CDHU e do programa Minha Casa Minha Vida? A Vivaz te explica! Acesse nosso site e confira essa e outras dúvidas!',
              content: `
            <p>Os três têm basicamente o mesmo objetivo: construir e financiar imóveis para famílias com rendas limitadas. A principal diferença está em quem administra cada um deles.</p>
            <ul>
                <li><strong>COHAB</strong>: Companhia de Habitação Popular, de responsabilidade dos governos municipais.</li>
                <li><strong>CDHU</strong>: Companhia de Desenvolvimento Habitacional e Urbano, administrado pelos governos estaduais.</li>
                <li><strong>MCMV</strong>: Minha Casa Minha Vida, programa criado pelo Governo Federal.</li>
          </ul>
            <p>Outro detalhe importante: quem já tem um financiamento em outro programa habitacional não pode participar do Minha Casa Minha Vida.</p>
          `,
            },
            {
              id: 4,
              title: 'Dá para construir pelo programa MCMV?',
              url: 'construir-com-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer construir com o Programa Minha Casa Minha Vida? A Vivaz te explica como! Acesse nossa página de dúvidas frequentes e saiba mais sobre essa e outras dúvidas.',
              content: `
            <p>Sim, você pode construir pelo Minha Casa Minha Vida. O programa tem duas opções pra isso:</p>
            <ul>
                <li>Financiamento para quem já tem um terreno no seu nome e quer construir sua nova casa nele (mas não pode haver mais nada já construído ali).</li>
                <li>Financiamento para quem quer comprar um terreno novo e construir sua casa.</li>
          </ul>
            <p>Mas se você quiser realizar o sonho da casa própria sem se preocupar com obras, fique de olho nos nossos lançamentos!</p>
          `,
            },
            {
              id: 5,
              title: 'O que é ITBI e Como Funciona o Registro de um Imóvel?',
              url: 'o-que-e-itbi',
              category: 'minhaCasaMinhaVida',
              description: 'A Vivaz preparou uma FAQ para que você entenda o que é ITBI e como funciona o procedimento de registro de imóveis para não deixar nada passar. Confira!',
              content: `
            <h5>O que é e como funciona o ITBI?</h5>
            <p>O Imposto Sobre Transmissão de Bens Imóveis, também conhecido só como ITBI, é um tributo municipal que precisa ser pago sempre que ocorre uma compra ou transferência de imóveis. Quem deve pagar esse imposto para a prefeitura da sua cidade é o comprador do imóvel e, caso esse pagamento não seja feito, a documentação não é liberada e o imóvel não pode ser vendido.</p>
            <p>O ITBI é calculado em porcentagem, mas como quem recebe esse valor é a prefeitura, o valor varia de cidade para cidade. Em São Paulo, por exemplo, é cobrado 3% do valor do negócio fechado. Em algumas outras cidades, o ITBI fica perto de 2% do valor do imóvel. Você pode dar uma olhada no site da sua prefeitura ou pedir ajuda para o consultor que estiver acompanhando sua compra.</p>
            <p>Esse imposto é cobrado só em casos de transferências de imóveis envolvendo pessoas vivas. Para casos de falecimento ou doação, é cobrado o Imposto sobre Transmissão “Causa Mortis” e Doação, também chamado de ITCMD.</p>
            <p>O ITBI pode ter algum desconto, mas só em casos de compra do primeiro imóvel com transação feita pelo Sistema Financeiro de Habitação (SFH).</p>
            <p>Já que ele é um tributo obrigatório, é bom se planejar desde o começo para não perder o controle das suas finanças e estar tranquilo na hora de pagar o ITBI, tudo bem?</p>
            <h5>Como funciona o registro de um imóvel?</h5>
            <p>A compra de um apartamento envolve muitos passos que parecem burocráticos, mas que são muito importantes para que tudo aconteça da melhor forma possível. Um desses passos é o registro do imóvel, que faz o reconhecimento formal da propriedade. Em outras palavras, oficialmente, só quem registra o imóvel se torna dono dele.</p>
            <p>Os documentos necessários para registrar um imóvel variam de acordo com o seu Estado, mas a lista básica é:</p>
            <ul>
            <li>RG;</li>
            <li>CPF;</li>
            <li>Profissão;</li>
            <li>Certidão de Nascimento/Casamento;</li>
            <li>Cópia do comprovante de residência;</li>
            </ul>
            <p>Depois de pagar o ITBI e a escritura, você já pode fazer o registro! Ele é encaminhado a um Cartório de Registros de Imóvel e costuma ter um prazo médio de 30 dias. O valor também depende do Estado, mas uma coisa é certa: se você está comprando seu primeiro imóvel no programa Minha Casa Minha Vida, a Lei de Registros Públicos (6.015/73) garante 50% de desconto no registro.</p>
          `,
            },
          ],
        },
        {
          id: 2,
          title: 'Como funciona?',
          image: '/Files/vivaz.com.br/content/img/icons/gear.svg',
          questions: [
            {
              id: 6,
              title: 'Como funciona o Minha Casa Minha Vida?',
              url: 'como-funciona-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer saber como funciona o Programa Minha Casa Minha Vida? Acesse a página de dúvidas frequentes da Vivaz que a gente te explica essa e outras dúvidas.',
              content: `
            <p>Com financiamentos facilitados com juros baixos, o Minha Casa Minha Vida ajuda milhões de brasileiros com o sonho da casa própria.</p>
            <p>O programa só permite a participação de pessoas com renda de até R$ 9.000,00. Ele divide as rendas participantes em 4 diferentes faixas, para que cada uma tenha sua própria taxa de juros e valores diferentes de subsídios:</p>
            <ul>
                <li>Famílias com renda de até R$ 1.800,00 - Faixa 1</li>
                <li>Famílias com renda de até R$ 2.600,00 - Faixa 1,5</li>
                <li>Famílias com renda de até R$ 4.000,00 - Faixa 2</li>
                <li>Famílias com renda de até R$ 9.000,00 - Faixa 3</li>
          </ul>
            <p>Mas a “renda familiar” abordada não é somente renda do casal ou entre pais e filhos. <a href='/duvidas-frequentes/faixas-de-renda-familiar-mcmv'>Clique aqui</a> para entender o que é renda familiar aceita pelo programa e ler mais sobre cada uma das faixas.</p>
            <p>Existem outras regras que determinam quem pode se inscrever, como não ter outro imóvel no seu nome e não ser funcionário da Caixa Econômica Federal. Para entender tudo sobre essas regras, <a href='duvidas-frequentes/quem-pode-se-cadastrar-mcmv'>clique aqui</a>.</p>
            <p>O Minha Casa Minha Vida tem alguns <a href='/duvidas-frequentes/vantagens-do-programa-mcmv'>benefícios</a> importantes, como parcelamento facilitado, <a href='/duvidas-frequentes/como-sao-calculados-juros-mcmv'>juros baixos</a> e <a href='/duvidas-frequentes/o-que-e-subsidio-e-como-e-calculado'>subsídios</a>. Além disso, você pode usar seu <a href='/duvidas-frequentes/usar-fgts-mcmv'>FGTS</a> para ajudar no pagamento da sua casa nova.</p>
            <p>O Governo exige vários documentos na hora do seu cadastro, pois ele analisa com muito cuidado cada inscrição, principalmente a comprovação da renda familiar. Nós listamos <a href='/duvidas-frequentes/documentos-necessarios-para-mcmv'>nessa página</a> todos os documentos exigidos para você não esquecer de nada.</p>
            <p>Se você quiser saber qual o passo a passo para ter seu Vivaz financiado através do Minha Casa Minha Vida, é só <a href='/duvidas-frequentes/como-ter-vivaz-pelo-mcmv'>clicar aqui</a>!</p>
          `,
            },
            {
              id: 7,
              title: 'O que preciso fazer para ter meu Vivaz pelo programa Minha Casa Minha Vida?',
              url: 'como-ter-vivaz-pelo-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'A Vivaz te ajuda a entender como funciona o programa Minha Casa Minha Vida. Acesse nossa página de dúvidas e saiba mais sobre essa e outras dúvidas de Minha Casa Minha Vida!',
              content: `
            <p>É muito fácil financiar seu Vivaz através do programa Minha Casa Minha Vida e nós damos todo o suporte para você e sua família durante o processo.</p>
            <ul>
                <li>Converse com um dos nossos consultores especializados e escolha o Vivaz perfeito pra você;</li>
                <li>Separe todos os documentos que são exigidos (original e cópia);</li>
                <li>Conte com a gente pra encaminhar tudo para a Caixa Econômica Federal</li>
                <li>Aguarde a aprovação do crédito no banco;</li>
                <li>Assine seu contrato com a gente;</li>
                <li>Quando o crédito for aprovado, assine o contrato do financiamento com a Caixa;</li>
                <li>Pronto! Bem-vindo a uma nova fase da vida.</li>
          </ul>
          `,
            },
            {
              id: 8,
              title: 'O que é renda familiar? Quais são as faixas de renda para participação no Minha Casa Minha Vida?',
              url: 'faixas-de-renda-familiar-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Saiba mais sobre a renda familiar necessária para contratação do Programa Minha Casa Minha Vida acessando a página de dúvidas frequentes da Vivaz. Confira!',
              content: `
            <p>Para deixar o financiamento mais leve no bolso, as pessoas que vão morar juntas podem unir suas rendas. Essa soma é chamada de renda familiar, mas pode ser feita com qualquer um que vai dividir seu lar com você, seja membro da família, amigo ou namorado(a). Exemplo: se dois colegas vão financiar o imóvel, um deles ganha R$ 1.100,00 e o outro R$ 1.200,00, a renda familiar é de R$ 2.300,00. </p>
            <p>Famílias com renda de até R$ 9.000,00 podem participar do programa. As rendas participantes são divididas por faixas:</p>
            <ul>
                <li>Famílias com renda de até R$ 1.800,00 - Faixa 1</li>
                <li>Famílias com renda entre R$ 1.801 até R$ 2.600,00 - Faixa 1,5</li>
                <li>Famílias com renda entre R$2.601 até R$ 4.000,00 - Faixa 2</li>
                <li>Famílias com renda entre R$4.001 até R$ 9.000,00 - Faixa 3</li>
          </ul>
            <p>No primeiro exemplo, a renda familiar dos colegas se encaixa na faixa 1,5.</p>
          `,
            },
            {
              id: 9,
              title: 'O que é subsídio? Como eles são calculados?',
              url: 'o-que-e-subsidio-e-como-e-calculado',
              category: 'minhaCasaMinhaVida',
              description: 'Você sabe o que é o subsídio e como ele é calculado? A Vivaz explica tudo que você precisa saber sobre ele. Acesse nossa página de de dúvidas e confira!',
              content: `
            <p>O subsídio é um empurrãozinho que o Governo dá na busca pelo seu sonho: ele paga uma parte da sua casa. Você não tem que se preocupar, pois não precisa dar esse dinheiro de volta para o Governo</p>
            <p>Exemplo: se você vai comprar um imóvel de R$ 115 mil e consegue um subsídio do Governo de R$ 15 mil, o valor que você terá que pagar vai ser apenas R$ 100 mil.</p>
            <p>Os valores dos subsídios que o Governo paga dependem de alguns fatores, como:</p>
            <ul>
                <li>Sua renda e a faixa onde ela se encaixa;</li>
                <li>A região onde você vai morar;</li>
                <li>Valor do imóvel.</li>
          </ul>
          `,
            },
          ],
        },
        {
          id: 3,
          title: 'Como participar?',
          image: '/Files/vivaz.com.br/content/img/icons/check.svg',
          questions: [
            {
              id: 9,
              title: 'Quem pode se cadastrar no Minha Casa Minha Vida?',
              url: 'quem-pode-se-cadastrar-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer saber se você pode se cadastrar no Programa Minha Casa Minha Vida? Acesse nossa página e saiba mais sobre essa e outras dúvidas de Minha Casa Minha Vida!',
              content: `
            <p>O MCMV tem algumas regras sobre quem pode ou não participar do programa para financiar a casa própria. Confira as principais exigências:</p>
            <ul>
                <li>Ter a renda familiar dentro das faixas criadas pelo programa (clique <a href='/duvidas-frequentes/faixas-de-renda-familiar-mcmv'>aqui</a> para entender);</li>
                <li>Não ser funcionário da Caixa Econômica Federal nem casado com um funcionário;</li>
                <li>Não ter recebido benefícios de qualquer <a href='/duvidas-frequentes/faixas-de-renda-familiar-mcmv'>outro programa habitacional</a>;</li>
                <li>Não ter nenhum imóvel no seu nome, ou seja: essa deve ser sua primeira casa própria;</li>
                <li>Ter o nome limpo.</li>
          </ul>
          `,
            },
            {
              id: 10,
              title: 'Quais os documentos necessários para se inscrever no Minha Casa Minha Vida?',
              url: 'documentos-necessarios-para-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'A Vivaz lista quais são os documentos necessários para o programa do Minha Casa Minha Vida. Acesse nossa página de dúvidas frequentes e saiba mais!',
              content: `
            <p>O programa Minha Casa Minha Vida exige alguns documentos para abrir o seu processo de participação. É muito importante que você separe com antecedência para não esquecer de nada. Nossa dica é que você tenha todos os documentos originais e mais uma cópia de cada um deles. Anote quais são:</p>
            <ul>
                <li>Documentos de identificação: RG e CPF</li>
                <li>Carteira de trabalho (CTPS);</li>
                <li>FGTS;</li>
                <li>Comprovante de estado civil (certidão de nascimento para solteiros, certidão de casamento para casados e certidão de casamento averbada para divorciados);</li>
                <li>Comprovante de residência recente;</li>
                <li>Declaração de contribuição do Imposto de Renda;</li>
                <li>Para assalariados: comprovante de renda (holerites) dos últimos 6 meses.</li>
          </ul>
            <p>Trabalhadores autônomos (quem trabalha por conta própria e sem carteira assinada) podem usar extratos bancários ou declaração de Imposto de Renda do último ano no lugar dos holerites para comprovar a renda.</p>
            <p>Se você vai juntar sua renda com a algum de amigo ou familiar para financiar o imóvel, não esqueça: é preciso apresentar os documentos de todos os envolvidos no processo!</p>
          `,
            },
            {
              id: 11,
              title: 'Como aumentar minha chance de aprovação de crédito no Minha Casa Minha Vida?',
              url: 'como-aumentar-chance-aprovacao-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer aumentar suas chances de aprovação no Programa Minha Casa Minha Vida? A Vivaz te ajuda! Acesse nossa página de dúvidas frequentes e confira!',
              content: `
            <p>Temos algumas dicas que podem ajudar seu crédito a ser aprovado pelo Minha Casa Minha Vida:</p>
            <ul>
                <li>Abra uma conta na Caixa Econômica: por ser do Governo Federal, a Caixa é o banco oficial do Minha Casa Minha Vida. Se você já tiver uma conta antes de se inscrever no programa, o banco já tem seu histórico como pagador e sua capacidade de pagamentos. Isso pode melhorar suas chances.</li>
                <li>Separe os documentos necessários com antecedência: evite deixar isso para última hora. Além disso, tenha tanto o documento original quanto uma cópia, por precaução. Sobre a comprovação da renda, você pode mostrar mais meses do que o banco pede. Para conferir os documentos exigidos pelo MCMV, <a href='/duvidas-frequentes/documentos-necessarios-para-mcmv'>clique aqui</a>.</li>
                <li>Mantenha sempre seu nome limpo. Não se preocupe: nós ajudamos você a encaminhar tudo ao banco e damos todo o suporte que você precisa durante o processo inteiro, desde a escolha do seu Vivaz até a entrega das chaves.</li>
          </ul>
            <p>Clique <a href='/duvidas-frequentes/como-ter-vivaz-pelo-mcmv'>aqui</a> e leia mais sobre o passo a passo de conquistar a casa própria com a gente financiando pelo Minha Casa Minha Vida.</p>
          `,
            },
            {
              id: 12,
              title: 'Como comprovar renda para o Minha Casa Minha Vida?',
              url: 'como-comprovar-renda-para-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer saber como comprovar sua renda para o programa Minha Casa Minha Vida? Acesse nossa página de dúvidas frequentes e confira como fazer!',
              content: `
            <p>A comprovação da sua renda é um dos passos mais importantes na aprovação da sua participação no MCMV. Inclusive, isso faz parte da documentação obrigatória exigida pelo programa (para ver todos, clique <a href='/duvidas-frequentes/documentos-necessarios-para-mcmv'>aqui</a>).</p>
            <p>A comprovação é feita através do seu holerite, um documento que demonstra todo o recebimento de dinheiro (salário e benefícios) dos funcionários de uma empresa. Para conseguir o seu holerite, é só falar com a área responsável no local onde você trabalha – entre em contato com o RH, financeiro ou seu chefe direto. Você precisa comprovar a renda dos últimos 6 meses, mas não custa ter essa informação com alguns meses a mais na hora de entregar os documentos.</p>
            <p>Se você é um trabalhador autônomo (trabalha por conta própria e sem carteira assinada), pode usar os seguintes documentos na comprovação da renda: declaração de Imposto de Renda do último ano; extratos bancários; RPA - Recebimento de Pagamento Autônomo (empresas que contratam autônomos emitem); comprovante de prestação de serviço, conhecido como recibo, emitidos por você mesmo quando faz um serviço.</p>
            <p>Para facilitar o processo, junte o máximo de documentos que puder.</p>
          `,
            },
          ],
        },
        {
          id: 4,
          title: 'Como é feito o financiamento?',
          image: '/Files/vivaz.com.br/content/img/icons/safe.svg',
          questions: [
            {
              id: 13,
              title: 'É preciso dar entrada? ',
              url: 'precisa-entrada-para-o-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Quer saber se é necessário dar entrada no Programa Minha Casa Minha Vida? A Vivaz te explica. Acesse nossa página de dúvidas e saiba mais!',
              content: `
            <p>Depende da renda da sua família.</p>
            <ul>
                <li>Se sua renda familiar se encaixa na faixa 1 e 1,5 (até R$ 2.600), pode ser que seu financiamento não necessite de entrada.</li>
                <li>Se sua renda familiar está nas faixas 2 e 3 (de R$ 2.700 até R$ 9.000), o pagamento da entrada é obrigatório. A boa notícia é que nós facilitamos a sua entrada, parcelando o pagamento! O pagamento dela</li>
          </ul>
            <p>Não sabe o que é renda familiar ou quer entender mais sobre as faixas criadas pelo MCMV? Nós explicamos <a href='/duvidas-frequentes/faixas-de-renda-familiar-mcmv'>aqui</a>!</p>
          `,
            },
            {
              id: 14,
              title: 'Qual o número máximo de parcelas?',
              url: 'numero-de-parcelas-maximas-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'A Vivaz te ajuda a entender como funciona o parcelamento máximo do Programa Minha Casa Minha Vida. Acesse nosso site e saiba mais sobre essa e outras dúvidas!',
              content: `
            <p>O MCMV oferece o maior parcelamento do mercado. O parcelamento máximo do programa é de 360 meses (30 anos).</p>
            <p>A quantidade de parcelas varia de acordo com a faixa da sua renda. Não sabe o que é renda familiar ou em qual faixa sua renda se encaixa? Nós explicamos <a href='/duvidas-frequentes/faixas-de-renda-familiar-mcmv'>aqui</a>!</p>
          `,
            },
            {
              id: 15,
              title: 'Tem juros? Qual o percentual?',
              url: 'como-sao-calculados-juros-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'A Vivaz te explica como funcionam os juros do Programa Minha Casa Minha Vida. Acesse nossa página de dúvidas frequentes e tenha todas as informações!',
              content: `
            <p>Sim, mas não se preocupe: as taxas de juros do Minha Casa Minha Vida são as menores do mercado. O programa tem taxas a partir de 5% ao ano.</p>
            <p>Não sabe o que é renda familiar? Nós explicamos <a href='/duvidas-frequentes/faixas-de-renda-familiar-mcmv'>aqui</a>!</p>
          `,
            },
            {
              id: 16,
              title: 'Como Funciona o Financiamento pelo Minha Casa Minha Vida?',
              url: 'como-funciona-financiamento-caixa-mcmv',
              category: 'minhaCasaMinhaVida',
              description: 'Você deseja adquirir um imóvel? A Vivaz te ajuda a entender como funciona  a contratação e financiamento Caixa do Programa Minha Casa Minha Vida. Confira!',
              content: `
            <h5>Financiamento Caixa Econômica</h5>
            <p>Você deseja adquirir um imóvel? O Minha Casa Minha Vida é um programa do Governo Federal com o apoio da Caixa Econômica que ajuda muitos brasileiros a realizarem o sonho da casa própria. </p>
            <p>A Caixa, responsável pela definição de critérios e contratação do programa, oferece planos com muitas vantagens para financiar a sua casa nova.</p>
            <p>Confira os benefícios do financiamento Caixa:</p>
            <ul>
              <li>Você pode parcelar seu imóvel em até 360 meses (30 anos);</li>
              <li>As taxas de juros são as mais baixas do mercado (a partir de 5% ao ano);</li>
              <li>Você pode contar com um subsídio por parte do Governo.</li>
            </ul>
            <p>O valor do subsídio da Caixa varia de acordo com alguns fatores, como a sua renda mensal, a região onde vai morar e o valor do imóvel.</p>
            <p>O melhor de tudo é que também é possível usar seu FGTS na entrada do financiamento, na quitação das parcelas ou na redução do seu saldo devedor.</p>

            <h5>Como contratar o MCMV?</h5>
            <p>As famílias com renda de até R$ 1800,00 devem se inscrever no programa na prefeitura da cidade ou em uma entidade organizadora. Depois, as famílias selecionadas pela prefeitura e validadas pela Caixa participam de um sorteio das unidades disponíveis.</p>
            <p>Se a sua renda for acima de R$1800,00 e até R$7000,00, você pode contratar o programa em uma entidade organizadora ou solicitar de maneira individual.</p>

            <p>Para isso, é preciso ir até uma agência da Caixa ou Correspondente Caixa Aqui para entregar a documentação necessária. Se a proposta for aprovada, o cadastro é validado e é feita a assinatura do contrato de financiamento.</p>

            <p>Utilize o simulador Vivaz e aproveite todas as vantagens do Financiamento Caixa!</p>
          `,
            },
          ],
        },
      ],
    },
    {
      habiteSeguro: [
        {
          id: 8,
          title: 'O que é?',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 23,
              title: 'O que é o programa Habite Seguro?',
              url: 'o-que-e-o-programa-habite-seguro',
              category: 'habiteSeguro',
              description: 'Quer saber o que é o Programa Habite Seguro? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre o Habite Seguro!',
              content: `
              <p>O Habite Seguro é um programa habitacional do governo que oferece aos profissionais de segurança pública, em todo território nacional, o suporte para aquisição da sua casa própria.</p>
              <p>São aplicadas taxas menores de juros e condições especiais de crédito imobiliário.</p>
            `,
            },
            {
              id: 24,
              title: 'Quais são os benefícios do programa Habite Seguro?',
              url: 'quais-sao-os-beneficios-do-programa-habite-seguro',
              category: 'habiteSeguro',
              description: 'Quer saber quais os benefícios do Programa Habite Seguro? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre o Habite Seguro!',
              content: `
              <p>Além de contar com taxas diferenciadas de financiamento, o profissional de segurança ainda conta com subvenção de parte da tarifa de contratação e em parte do financiamento imobiliário.</p>
              <p>Podem ser adquiridos imóveis novos, usados ou em construção.</p>
            `,
            },
          ],
        },
        {
          id: 9,
          title: 'Como funciona?',
          image: '/Files/vivaz.com.br/content/img/icons/gear.svg',
          questions: [
            {
              id: 25,
              title: 'Como funciona o Habite Seguro?',
              url: 'como-funciona-o-habite-seguro',
              category: 'habiteSeguro',
              description: 'Quer saber como funciona o Programa Habite Seguro? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre o Habite Seguro!',
              content: `
              <p>O programa oferece aos profissionais de segurança subsídios de até R$ 2.100 para financiar imóveis de até R$ 300 mil, com auxílio de até R$ 12 mil no pagamento de entrada. Esse apoio pode ser somado ao subsídio do programa Casa Verde e Amarela.</p>
            `,
            },
          ],
        },
        {
          id: 10,
          title: 'Como participar?',
          image: '/Files/vivaz.com.br/content/img/icons/check.svg',
          questions: [
            {
              id: 26,
              title: 'Quem pode participar do programa Habite Seguro?',
              url: 'quem-pode-participar-do-programa-habite-seguro',
              category: 'habiteSeguro',
              description: 'Quer saber quem pode participar do Programa Habite Seguro? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre o Habite Seguro!',
              content: `
              <p>O Programa Nacional de Apoio à Aquisição de Habitação para Profissionais de Segurança Pública (Habite Seguro) busca favorecer o seguinte público:</p>
              <ul>
                <li>Policiais federais, rodoviários, civis, penais e militares; agentes das guardas municipais; bombeiros, agentes penitenciários, peritos e profissionais dos institutos de criminalística, medicina legal e identificação;</li>
                <li>Profissionais inativos da reserva remunerada, reformados ou aposentados.</li>
              </ul>
              <p>Importante: o programa é voltado aos profissionais com renda bruta mensal de até R$ 7 mil e que não possuam imóvel próprio.</p>
            `,
            },
          ],
        },
        {
          id: 11,
          title: 'Como é feito o financiamento?',
          image: '/Files/vivaz.com.br/content/img/icons/safe.svg',
          questions: [
            {
              id: 27,
              title: 'Como é feita a inscrição no Habite Seguro?',
              url: 'como-e-feita-a-inscricao-no-habite-seguro',
              category: 'habiteSeguro',
              description: 'Quer saber como é feita a inscrição no Programa Habite Seguro? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre o Habite Seguro!',
              content: `
              <p>Interessados em solicitar esse novo crédito habitacional do governo devem procurar uma agência da CAIXA ou instituições financeiras credenciadas.</p>
              <p>A contratação está sujeita à aprovação de crédito do solicitante.</p>
            `,
            },
            {
              id: 28,
              title: 'Quais são as taxas e condições de financiamento?',
              url: 'quais-sao-as-taxas-e-condicões-de-financiamento',
              category: 'habiteSeguro',
              description: 'Quer saber quais são as taxas e condições de financiamento do Programa Habite Seguro? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre o Habite Seguro!',
              content: `
              <p>O prazo de pagamento é de até 35 anos. A cota de financiamento do Programa Casa Verde e Amarela para imóvel usado, de acordo com a Tabela Price é de até 80%. Se for utilizada a linha de crédito SBPE, fica em até 90%. Taxa Poupança da CAIXA a partir de 2,95% ao ano e carência de até 6 meses para início da amortização.</p>
            `,
            },
          ],
        },
      ],
    },
    {
      jornada: [
        {
          id: 12,
          title: 'Boas-vindas: Contato',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 29,
              title: 'Quero que me chamem por outro nome. Como faço isso?',
              url: 'quero-que-me-chamem-por-outro-nome-jornada-boas-vindas-contato',
              category: 'jornada',
              description: 'Quer saber como ser chamado por outro nome? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de Boas-vindas!',
              content: `
              <p>Para mudar seu nome, clique em sua foto de perfil (localizada na home) e selecione a opção ‘Atualização Cadastral’. No campo indicado para o nome, informe como devemos te chamar.</p>
              <p>A atualização será feita em nosso app, portal e demais comunicações. Para os documentos do imóvel, irá constar o nome que estava em seu documento no momento da compra.</p>
            `,
            },
            {
              id: 30,
              title: 'Posso deixar de receber e-mails?',
              url: 'posso-deixar-de-receber-e-mails-jornada-boas-vindas-contato',
              category: 'jornada',
              description: 'Quer saber deixar de receber e-mails? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de Boas-vindas!',
              content: `
              <p>Não é possível deixar de receber e-mails. É através dessa forma de contato que você irá acompanhar conteúdos relevantes sobre seu apartamento, como detalhes da obra, informações financeiras, convites para vistorias, assembleias e outros eventos.</p>
              <p>Mas não se preocupe: prometemos enviar e-mails somente quando for realmente necessário. :)</p>
            `,
            },
          ],
        },
        {
          id: 13,
          title: 'Boas-vindas: Contrato',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 31,
              title: 'É possível trocar de unidade?',
              url: 'e-possivel-trocar-de-unidade-jornada-boas-vindas-contrato',
              category: 'jornada',
              description: 'Quer saber se é possível trocar de unidade? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de Boas-vindas!',
              content: `
              <p>Depende do caso. Antes de qualquer decisão, visite o site de vendas da Cyrela, Living ou Vivaz e descubra qual empreendimento te interessa. Após a escolha, vá em ‘Fale Conosco’ e informe seu desejo de troca.</p>
              <p>Feito isso, aguarde o nosso retorno. Logo entraremos em contato para discutir condições, valores e taxas.</p>
            `,
            },
            {
              id: 32,
              title: 'Quero rescindir o meu contrato. O que devo fazer?',
              url: 'quero-rescindir-o-meu-contrato-jornada-boas-vindas-contrato',
              category: 'jornada',
              description: 'Quer saber como rescindir o seu contrato? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de Boas-vindas!',
              content: `
              <p>Vá até o ‘Fale Conosco’ e solicite a rescisão. Depois, espere até entrarmos em contato com você para explicar as condições e cláusulas do contrato, além dos demais procedimentos necessários.</p>
            `,
            },
          ],
        },
        {
          id: 14,
          title: 'Entrega: Condomínio',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 33,
              title: 'O que é um condomínio?',
              url: 'o-que-e-um-condominio-jornada-entrega-condominio',
              category: 'jornada',
              description: 'Quer saber o que é um condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Condomínio é a propriedade dividida por um grupo de pessoas, onde cada uma possui uma parte do todo.</p>
              <p>Depois que o Habite-se for expedido, nós iremos te convidar para a Assembleia de Instalação do Condomínio. Nesse evento, faremos a eleição do síndico ou síndica e do conselho consultivo.</p>
              <p>A partir desse momento, você irá iniciar uma vida em comunidade com seus novos vizinhos e vizinhas. Por isso, será importante conhecer e respeitar as regras e os procedimentos estabelecidos. Além disso, você e o corpo diretivo eleito na assembleia contarão com uma equipe de funcionários e uma administradora para auxiliar na gestão do condomínio.</p>
            `,
            },
            {
              id: 34,
              title: 'Quais leis e normas regem o condomínio?',
              url: 'quais-leis-e-normas-regem-o-condominio-jornada-entrega-condominio',
              category: 'jornada',
              description: 'Quer saber quais leis e normas regem o condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>As normas gerais estão localizadas na Convenção do Condomínio. Você pode conferir a minuta na página de ‘Documentos’, em nosso site. Há também o Novo Código Civil (Lei nº 10.406/02), em seus artigos de 1.331 a 1.358, e a Lei nº 4.591/64, em seus artigos que não foram revogados pelo Novo Código Civil.</p>
              <p>Além disso, após a Assembleia de Instalação, é possível que aconteçam novas reuniões para aprovar regulamentos e outras questões.</p>
            `,
            },
            {
              id: 35,
              title: 'Qual será a administradora do condomínio? Como ela é escolhida?',
              url: 'qual-sera-a-administradora-do-condominio-e-como-ela-e-escolhida-jornada-entrega-condominio',
              category: 'jornada',
              description: 'Quer saber qual será a administradora do condomínio e como ela é escolhida? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Cerca de dois meses antes da entrega do condomínio, a Vivaz irá te convidar para fazer parte da escolha da administradora. Indicaremos três administradoras com reconhecimento no mercado, para que você e todos os moradores votem na de sua preferência.</p>
              <p>O ideal é que a administradora permaneça durante o primeiro mandato. Assim, garantimos que o corpo diretivo receberá a orientação mais adequada.</p>
            `,
            },
          ],
        },
        {
          id: 15,
          title: 'Entrega: Documentos',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 36,
              title: 'O que é a escritura do imóvel? Como posso realizá-la?',
              url: 'o-que-e-a-escritura-do-imovel-e-como-posso-realiza-la-jornada-entrega-documentos',
              category: 'jornada',
              description: 'Quer saber o que é a escritura do imóvel e como posso realizá-la? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>A escritura é o único documento que representa a posse legal do imóvel. É por meio dela que acontece a transferência da titularidade e de todos os direitos para o seu nome.</p>
              <p>Para casos de financiamento, a escritura é o registro do contrato com a instituição financeira. Já para casos de quitação com recursos próprios, esse processo poderá ser iniciado após o registro da instituição, especificação e convenção de condomínio.</p>
              <p>O prazo para emissão desses documentos é de aproximadamente 90 dias após a expedição do Habite-se. Você deve reunir os seguintes documentos:</p>
              <ul>
                <li>Termo de quitação;</li>
                <li>Promessa de compra e venda;</li>
                <li>IPTU do ano vigente ou número do contribuinte;</li>
                <li>Cópia da matrícula atualizada – este documento poderá ser solicitado no cartório onde seu imóvel foi registrado. Verifique o item 3 de sua promessa de compra e venda;</li>
                <li>Cópia dos documentos de identificação de todos os compradores (caso tenha mais de um)  – RG, CPF, certidão de casamento ou nascimento e comprovante de endereço atualizado.</li>
              </ul>
              <p>O cartório também pode solicitar outros documentos e pagamento de despesas, como taxas notariais e recolhimento do ITBI. Lembre-se que essas solicitações são de responsabilidade do cliente, conforme o contrato. Você pode iniciar este processo no cartório de sua preferência ou em um de nossa indicação.</p>
            `,
            },
            {
              id: 37,
              title: 'O que é Manual do Proprietário?',
              url: 'o-que-e-manual-do-proprietario-jornada-entrega-documentos',
              category: 'jornada',
              description: 'Quer saber o que é Manual do Proprietário? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>O Manual do Proprietário é um documento que contém todas as informações sobre o imóvel, como orientações sobre seu uso, conservação, manutenção preventiva e condições de garantia.</p>
              <p>Além disso, ele indica os principais fornecedores e informa como deve ser a utilização e a manutenção correta das áreas e equipamentos, a fim de evitar danos decorrentes de mau uso. Ele também esclarece sobre os riscos de perda de garantia pela falta de conservação e manutenção preventiva adequada.</p>
            `,
            },
            {
              id: 38,
              title: 'O que é um Memorial Descritivo?',
              url: 'o-que-e-um-memorial-descritivo-jornada-entrega-documentos',
              category: 'jornada',
              description: 'Quer saber o que é um Memorial Descritivo? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>O Memorial Descritivo é um documento que informa os itens e sistemas que serão entregues em um empreendimento, tanto para a área comum quanto para os apartamentos. Nele, constam informações importantes sobre os acabamentos previstos para cada ambiente.</p>
            `,
            },
            {
              id: 39,
              title: 'O que é Planta Baixa?',
              url: 'o-que-e-planta-baixa-jornada-entrega-documentos',
              category: 'jornada',
              description: 'Quer saber o que é Planta Baixa? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>A Planta Baixa é o desenho do edifício ou apartamento, no sentido do teto para o piso, em toda a sua extensão.</p>
            `,
            },
            {
              id: 40,
              title: 'Por que devo registrar a escritura do imóvel?',
              url: 'por-que-devo-registrar-a-escritura-do-imovel-jornada-entrega-documentos',
              category: 'jornada',
              description: 'Quer saber o porquê você deve registrar a escritura do imóvel? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>O registro na matrícula do imóvel é obrigatório para que a transferência da propriedade aconteça após a assinatura da escritura. Esse processo deve ser realizado no cartório de registro do imóvel, previsto em sua promessa de compra e venda (descrita no item 3).</p>
            `,
            },
            {
              id: 41,
              title: 'Posso ficar com uma cópia do documento de Habite-se?',
              url: 'posso-ficar-com-uma-copia-do-documento-de-habite-se-jornada-entrega-documentos',
              category: 'jornada',
              description: 'Quer saber se pode ficar com uma cópia do documento de Habite-se? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Sim, podemos enviar uma cópia por e-mail ou pelos Correios. Além disso, a cópia do documento fica disponível na área 'Documentos', no Portal do Cliente, em nosso site.</p>
            `,
            },
          ],
        },
        {
          id: 16,
          title: 'Entrega: Reforma',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 42,
              title: 'Quero fazer uma reforma no apartamento. Como devo proceder?',
              url: 'quero-fazer-uma-reforma-no-apartamento-como-devo-proceder-jornada-entrega-reforma',
              category: 'jornada',
              description: 'Quer fazer uma reforma no apartamento e quer saber como deve proceder? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Para fazer uma reforma, você deve avisar o condomínio antecipadamente, de acordo com a Norma Brasileira (NBR) 16.280. Qualquer alteração no imóvel deve ser feita sob orientação de profissionais e empresas qualificadas.</p>
              <p>Em caso de reforma ou descaracterização de algum sistema entregue pela construtora, o item relacionado à alteração estará fora da garantia dada pela mesma.</p>
            `,
            },
          ],
        },
        {
          id: 17,
          title: 'Entrega: Entrega',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 43,
              title: 'Como faço para pegar as chaves da minha unidade?',
              url: 'como-faco-para-pegar-as-chaves-da-minha-unidade-jornada-entrega-entrega',
              category: 'jornada',
              description: 'Quer saber como fazer para pegar as chaves da sua unidade? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Assim que sua unidade estiver pronta, entraremos em contato para agendar a entrega das chaves. Você poderá receber as chaves no seu endereço cadastrado ou em nosso escritório.</p>
            `,
            },
            {
              id: 44,
              title: 'Como é feita a entrega da área comum?',
              url: 'como-e-feita-a-entrega-da-area-comum-jornada-entrega-entrega',
              category: 'jornada',
              description: 'Quer saber como é feita a entrega da área comum? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Após a instalação do condomínio, faremos a vistoria da área comum junto ao corpo diretivo eleito, para garantir que o edifício seja entregue conforme o Memorial Descritivo. Depois que a vistoria for aceita, é feita a entrega das áreas comuns.</p>
            `,
            },
            {
              id: 45,
              title: 'O que é Assembleia de Instalação do Condomínio?',
              url: 'o-que-e-assembleia-de-instalacao-do-condominio-jornada-entrega-entrega',
              category: 'jornada',
              description: 'Quer saber o que é Assembleia de Instalação do Condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>É um ato jurídico que marca o momento em que o condomínio é instalado. Neste dia, é feita a eleição do corpo diretivo, aprovação orçamentária inicial, lavratura de uma ata-documento (exigida para obtenção do CNPJ) e outros documentos. Isso permitirá que o condomínio pratique os atos jurídicos e fiscais necessários para sua administração.</p>
            `,
            },
            {
              id: 46,
              title: 'Não posso comparecer à Assembleia de Instalação do Condomínio. O que eu devo fazer?',
              url: 'nao-posso-comparecer-a-assembleia-de-instalacao-do-condominio-jornada-entrega-entrega',
              category: 'jornada',
              description: 'Quer saber o que fazer quando não puder comparecer à Assembleia de Instalação do Condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Você pode enviar uma pessoa de confiança para te representar, desde que ela leve uma procuração com firma reconhecida. Caso ninguém possa ir em seu lugar, não tem problema: após a assembleia, a administradora do condomínio irá te enviar uma cópia da ata com tudo que foi discutido e acordado na reunião.</p>
            `,
            },
            {
              id: 47,
              title: 'Quando ocorre a instalação do condomínio?',
              url: 'quando-ocorre-a-instalacao-do-condominio-jornada-entrega-entrega',
              category: 'jornada',
              description: 'Quer saber quando ocorre a instalação do condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de entrega!',
              content: `
              <p>Após a emissão do Habite-se, vamos te enviar o edital da Assembleia de Instalação do Condomínio, informando o dia e horário do evento. Essa será a primeira reunião entre os condôminos e a empresa indicada para administrar o condomínio.</p>
            `,
            },
          ],
        },
        {
          id: 18,
          title: 'Garantia: Imóvel',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 48,
              title: 'Quais são as garantias para eventuais problemas construtivos?',
              url: 'quais-sao-as-garantias-para-eventuais-problemas-construtivos-jornada-garantia-imovel',
              category: 'jornada',
              description: 'Quer saber quais são as garantias para eventuais problemas construtivos? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de garantia!',
              content: `
              <p>As estruturas das edificações são garantidas por até cinco anos, a partir do Auto de Conclusão do Imóvel. Para não perder o prazo, é importante não realizar nenhuma modificação ou alteração das características básicas do imóvel. Reforçamos também a importância de seguir todas as recomendações do manual, pois a garantia pode ser suspensa caso as recomendações não tenham sido seguidas. </p>
              <p>Nossa missão é garantir que o edifício seja entregue de acordo com o previsto no Memorial Descritivo. Por isso, te avisaremos quando chegar o momento de fazer a vistoria do seu imóvel. Durante a visita, será possível verificar todos os detalhes do apartamento, como pintura, integridade de louças, metais etc. Para eventuais defeitos, que não possam ser detectados na vistoria, você contará com o nosso serviço de assistência técnica. </p>
              <p>Além disso, no Manual do Proprietário e Síndico, você encontra o Termo de Garantia com todos os prazos.</p>
            `,
            },
          ],
        },
        {
          id: 19,
          title: 'Construção: Personalização',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 49,
              title: 'Posso retirar a porta da sala para o terraço?',
              url: 'posso-retirar-a-porta-da-sala-para-o-terraco-jornada-construcao-personalizacao',
              category: 'jornada',
              description: 'Quer se pode retirar a porta da sala para o terraço? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua Jornada de construção!',
              content: `
              <p>Durante a fase de personalização, não é possível optar pela retirada da porta, pois isso implicaria em um projeto diferente do que foi previamente aprovado com a Prefeitura. Porém, após a entrega do condomínio, é possível retirar a porta, desde que a medida seja aprovada pela convenção.</p>
            `,
            },
          ],
        },
      ],
    },
    {
      financas: [
        {
          id: 20,
          title: 'Tire suas dúvidas sobre finanças aqui!',
          image: '/Files/vivaz.com.br/content/img/icons/safe.svg',
          questions: [
            {
              id: 50,
              title: 'O que é e para que serve o Informe de Rendimentos?',
              url: 'o-que-e-e-para-que-serve-o-informe-de-rendimentos-financas',
              category: 'financas',
              description: 'Quer saber O que é e para que serve o Informe de Rendimentos? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>O Informe de Rendimentos é um documento que contém os registros dos investimentos que você fez ou recebeu no ano anterior, além das deduções que já pode ter sofrido. Ele serve como um guia para o preenchimento da sua declaração do Imposto de Renda. </p>
              <p>Além disso, é emitido pela empresa onde você trabalha, por instituições financeiras e demais companhias onde você tem investimentos, como construtoras.</p>
              `,
            },
            {
              id: 51,
              title: 'Como consigo o Informe de Rendimentos do meu Vivaz?',
              url: 'como-consigo-o-informe-de-rendimentos-do-meu-vivaz-financas',
              category: 'financas',
              description: 'Quer saber Como consigo o Informe de Rendimentos do meu Vivaz? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>O Informe de Rendimentos é um documento que auxilia o preenchimento do Imposto de Renda. Você pode baixar o documento em nosso Portal do Cliente: vá até a aba "Financeiro" e clique em "Informe de Rendimentos". O documento estará disponível durante o período de entrega da declaração do Imposto de Renda.</p>
              `,
            },
            {
              id: 52,
              title: 'Emiti o Informe de Rendimentos, mas está em nome de apenas um dos compradores. O que devo fazer?',
              url: 'emiti-o-informe-de-rendimentos-mas-esta-em-nome-de-apenas-um-dos-compradores-o-que-devo-fazer-financas',
              category: 'financas',
              description: 'Quer saber Emiti o Informe de Rendimentos, mas está em nome de apenas um dos compradores. O que devo fazer? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>O documento é emitido com o mesmo nome que consta nos boletos bancários. Caso o imóvel tenha sido comprado por mais de uma pessoa, procure uma empresa de contabilidade para te auxiliar na declaração correspondente à sua participação no contrato. </p>
              <p>Se surgir mais alguma dúvida ou precisar de ajuda, entre em contato com a gente em "Fale Conosco" ou pela Central de Atendimento: 4000-1850.</p>
              `,
            },
            {
              id: 53,
              title: 'Como declaro meu Imposto de Renda?',
              url: 'como-declaro-meu-imposto-de-renda-financas',
              category: 'financas',
              description: 'Quer saber Como declaro meu Imposto de Renda? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Primeiro, você precisa baixar o programa de declaração no site do Governo Federal, acessando <a href='https://www.gov.br/pt-br/servicos/declarar-meu-imposto-de-renda' target='_blank' rel='noreferer noopener'>aqui</a> . Depois, confira a matéria que preparamos para você  e descubra como declarar um imóvel financiado no Imposto de Renda.</p>
              `,
            },
            {
              id: 54,
              title: 'O que são Juros de Obra e como isso interfere no valor pago?',
              url: 'o-que-sao-juros-de-obra-e-como-isso-interfere-no-valor-pago-financas',
              category: 'financas',
              description: 'Quer saber O que são Juros de Obra e como isso interfere no valor pago? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Também conhecidos como Taxa de Evolução de Obra, os Juros de Obra são a porcentagem referente ao andamento da obra, que é paga ao banco que financia a construção até a finalização da obra. As dúvidas relacionadas a esse tema, como valores e pagamentos, devem ser resolvidas diretamente com o banco.</p>
              `,
            },
            {
              id: 55,
              title: 'O que significa DDA e Débito Automático?',
              url: 'o-que-significa-dda-e-debito-automatico-financas',
              category: 'financas',
              description: 'Quer saber O que significa DDA e Débito Automático? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>DDA é a sigla de Débito Direto Autorizado, um serviço bancário de apresentação eletrônica do boleto, que não implica necessariamente em seu pagamento. É uma forma de substituir a emissão de boletos impressos: você visualiza a cobrança na sua conta e autoriza ou não o pagamento.</p>
              <p>Já o Débito Automático* consiste no débito do dinheiro da conta, na data do vencimento. Ao contratar esse serviço, o banco para de enviar o boleto até sua casa.</p>
              <p><em>*A Cyrela não trabalha com a modalidade de débito automático.</em></p>
              `,
            },
            {
              id: 56,
              title: 'Quero cancelar minha adesão ao DDA. Como faço isso?',
              url: 'quero-cancelar-minha-adesao-ao-dda-como-faco-isso-financas',
              category: 'financas',
              description: 'Quer saber Quero cancelar minha adesão ao DDA. Como faço isso? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Para cancelar o Débito Direto Autorizado (DDA), você deve entrar em contato diretamente com seu banco.</p>
              `,
            },
            {
              id: 57,
              title: 'O que é hipoteca?',
              url: 'o-que-e-hipoteca-financas',
              category: 'financas',
              description: 'Quer saber O que é hipoteca? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Hipoteca é uma prática comum no mercado, em que um imóvel é oferecido como garantia de um empréstimo, mas sem passá-lo para o nome do credor. </p>
              `,
            },
            {
              id: 58,
              title: 'Como faço para efetuar pagamentos?',
              url: 'como-faco-para-efetuar-pagamentos-financas',
              category: 'financas',
              description: 'Quer saber Como faço para efetuar pagamentos? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Nós enviamos o boleto para o pagamento próximo à data de vencimento. Caso não receba, você poderá emitir a 2ª via do boleto no Portal do Cliente. Para isso, clique em "Menu"> 'Financeiro' > 'Meus Boletos'.</p>
              `,
            },
            {
              id: 59,
              title: 'Não estou recebendo meu boleto em casa. O que aconteceu?',
              url: 'nao-estou-recebendo-meu-boleto-em-casa-o-que-aconteceu-financas',
              category: 'financas',
              description: 'Quer saber Não estou recebendo meu boleto em casa. O que aconteceu? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Primeiro, confira se seus dados estão atualizados no Portal do Cliente. Se estiver tudo certo, sugerimos que converse com o banco para entender se há alguma forma alternativa de cobrança ativa, como o Débito Direto Autorizado (DDA). </p>
              <p>Se você não tiver nenhum desses serviços ativos, entre em contato com a gente através do "Fale conosco".</p>
              `,
            },
            {
              id: 60,
              title: 'Posso alterar o dia do vencimento das minhas parcelas?',
              url: 'posso-alterar-o-dia-do-vencimento-das-minhas-parcelas-financas',
              category: 'financas',
              description: 'Quer saber Posso alterar o dia do vencimento das minhas parcelas? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Pode. Para isso, clique em 'Menu' > 'Fale conosco'. Escolha a melhor data entre as oferecidas (05, 07 ou 10 de cada mês) e informe quais parcelas você deseja modificar (mensal ou anual).</p>
              <p>Importante: as parcelas já enviadas para o banco não podem ser alteradas. Se você já está na fase de financiamento, o vencimento da parcela deve ser resolvido diretamente com o banco.</p>
              `,
            },
            {
              id: 61,
              title: 'Posso antecipar parcelas ou valores do meu contrato?',
              url: 'posso-antecipar-parcelas-ou-valores-do-meu-contrato-financas',
              category: 'financas',
              description: 'Quer saber Posso antecipar parcelas ou valores do meu contrato? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Pode. Para isso, clique em 'Menu' > 'Financeiro' > 'Antecipação'.</p>
              `,
            },
            {
              id: 62,
              title: 'Posso pagar parte do boleto que recebi?',
              url: 'posso-pagar-parte-do-boleto-que-recebi-financas',
              category: 'financas',
              description: 'Quer saber Posso pagar parte do boleto que recebi? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>Pode. Para pagar apenas parte de uma parcela, entre em contato com a gente através do 'Fale conosco'. Na mensagem, descreva sua proposta e os detalhes referentes à parcela que deseja negociar. Nossa equipe entrará em contato logo após a análise do pedido.</p>
              `,
            },
            {
              id: 63,
              title: 'Qual é o prazo para confirmar uma parcela que paguei?',
              url: 'qual-e-o-prazo-para-confirmar-uma-parcela-que-paguei-financas',
              category: 'financas',
              description: 'Quer saber Qual é o prazo para confirmar uma parcela que paguei? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a sua finanças!',
              content: `
              <p>A parcela é efetivada em até cinco dias úteis após o pagamento e você pode acompanhar sua confirmação através do seu extrato financeiro. Para isso, clique em "Menu" > "Financeiro" > "Extrato Financeiro". </p>
              <p>Caso sua parcela ainda não conste como paga após esse período, entre em contato com a gente por meio do "Fale Conosco". Informe sobre qual parcela está falando e envie o comprovante de pagamento junto com o boleto. Depois, é só esperar nosso retorno.</p>
              `,
            },
          ],
        },
      ],
    },
    {
      leiDoSilencio: [
        {
          id: 21,
          title: 'Tire suas dúvidas sobre a Lei do Silêncio!',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 64,
              title: 'O que é a lei do silêncio?',
              url: 'o-que-e-a-lei-do-silencio-lei-do-silencio',
              category: 'leiDoSilencio',
              description: 'Quer saber o que é a Lei do Silêncio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a Lei do Silêncio!',
              content: `
              <p>A lei do silêncio se refere a um conjunto de leis - federais, estaduais ou municipais – que limitam a produção de barulhos que podem prejudicar a saúde, a segurança e o sossego dos indivíduos. Apesar de não existir uma lei editada pelo legislativo com o nome de “silêncio”, diversos artigos da constituição abordam o tema.</p>
              <p>O artigo 1277, da Lei 10.406/02, afirma que qualquer pessoa que possui uma propriedade pode “fazer cessar as interferências prejudiciais à segurança, ao sossego e à saúde dos que o habitam, provocadas pela utilização de propriedade vizinha”.</p>
              <p>Já a Norma Brasileira (NBR) 10151:2019, determina que os ruídos em áreas residenciais não devem ultrapassar os 50 decibéis durante a noite (das 20h às 7h).</p>
              <p>Podem ser considerados como barulho e ruído:</p>
              <ul>
                <li>Gritaria e tumulto;</li>
                <li>Atividades profissionais barulhentas ou incômodas, como obras e reformas;</li>
                <li>Instrumentos sonoros excessivamente altos;</li>
                <li>Sons guturais.</li>
              </ul>
              `,
            },
            {
              id: 65,
              title: 'Como funciona a lei do silêncio em condomínio?',
              url: 'como-funciona-a-lei-do-silencio-em-condominio-lei-do-silencio',
              category: 'leiDoSilencio',
              description: 'Quer saber como funciona a lei do silêncio em condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a Lei do Silêncio!',
              content: `
              <p>Por não existir uma lei do silêncio definitiva, as regras podem variar de acordo com o Regimento Interno de cada condomínio. Todo morador ou moradora tem o direito de possuir uma cópia desse documento e consultá-lo sempre que necessário.</p>
              <p>Entretanto, vale ressaltar que as regras podem ser muito amplas e não se enquadrar em todos os casos.  Afinal, o que é incômodo para uma pessoa pode não ser para outra. Nesse caso, é importante estabelecer o bom senso, para que a harmonia prevaleça no condomínio e todos exerçam sua liberdade sem incomodar a vizinhança.</p>
              <p>Além disso, a localização do empreendimento deve ser levada em consideração: regiões com bares e casas noturnas tendem a ser mais barulhentas do que áreas próximas a hospitais, por exemplo.</p>
              <p>De qualquer forma, é importante ter consciência do Regimento Interno do condomínio e seguir as normas estabelecidas no documento.</p>
              `,
            },
            {
              id: 66,
              title: 'Qual é o horário de silêncio?',
              url: 'qual-e-o-horario-de-silencio-lei-do-silencio',
              category: 'leiDoSilencio',
              description: 'Quer saber qual é o horário de silêncio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a Lei do Silêncio!',
              content: `
              <p>O horário de silêncio pode variar de acordo com cada região. O mais usado é o definido pela Norma Brasileira (NBR) 10.151/2000, que estabelece o limite de:</p>
              <ul>
                <li>Até 70 decibéis entre as 8h e 19h (período diurno);</li>
                <li>até 50 decibéis entre as 20h e 7h (período noturno).</li>
              </ul>
              <p>Para domingos e feriados, o período noturno se estende até às 9h. Além disso, é recomendado que você siga os horários previstos no Regimento Interno de sua moradia.</p>
              `,
            },
            {
              id: 67,
              title: 'Como denunciar o barulho?',
              url: 'como-denunciar-o-barulho-lei-do-silencio',
              category: 'leiDoSilencio',
              description: 'Quer saber como denunciar o barulho? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a Lei do Silêncio!',
              content: `
              <p>Antes de qualquer coisa, é preciso usar o bom senso e definir se a situação é de fato abusiva. Para isso, você deve levar em conta três fatores principais: intensidade do ruído, horário e histórico de perturbação.</p>
              <p>Em um primeiro momento, você pode entrar em contato direto com o morador ou moradora responsável pelo barulho. Se o incômodo continuar, fale com o síndico ou com a administradora do condomínio, para que os procedimentos do Regimento Interno sejam seguidos.</p>
              <p>Na maioria das vezes, a pessoa responsável pelo barulho é advertida formalmente, através de e-mail ou correspondência. Na pior das hipóteses, a advertência poderá ser usada como prova em uma ação judicial.</p>
              `,
            },
            {
              id: 68,
              title: 'Qual é a pena para quem desrespeita a lei do silêncio?',
              url: 'qual-e-a-pena-para-quem-desrespeita-a-lei-do-silencio',
              category: 'leiDoSilencio',
              description: 'Quer saber qual é a pena para quem desrespeita a lei do silêncio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre a Lei do Silêncio!',
              content: `
              <p>Segundo a Lei das Contravenções Penais, quem desrespeitar o silêncio pode cumprir de 15 dias a três meses de prisão, além de pagar multa.</p>
              <p>Antes de ser penalizada, a pessoa ou instituição responsável pelo barulho é advertida, com um pedido de silêncio. Se a perturbação continuar, poderá haver prisão por crime de desobediência.</p>
              `,
            },
          ],
        },
      ],
    },
    {
      sindico: [
        {
          id: 22,
          title: 'Tire suas dúvidas sobre síndico!',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 69,
              title: 'Quais são as obrigações do síndico?',
              url: 'quais-sao-as-obrigacoes-do-sindico',
              category: 'sindico',
              description: 'Quer saber quais são as obrigações do síndico? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre síndico!',
              content: `
              <p>O síndico é responsável pelo gerenciamento do condomínio e atua como representante dos moradores, garantindo a preservação da propriedade e o bem-estar de todos que ali habitam.</p>
              <p>Os principais deveres do síndico  são:</p>
              <ul>
                <li>Representar legalmente o condomínio e seus moradores;</li>
                <li>Manter o bom convívio entre os moradores;</li>
                <li>Evitar a infração das normas do prédio;</li>
                <li>Monitorar a segurança geral do imóvel;</li>
                <li>Organizar as finanças do condomínio;/li>
                <li>Pagar os funcionários;</li>
                <li>Prestar contas aos moradores, pelo menos uma vez ao ano;</li>
                <li>Organizar reuniões sempre que for necessário.</li>
              </ul>
              `,
            },
            {
              id: 70,
              title: 'Síndico recebe salário?',
              url: 'sindico-recebe-salario',
              category: 'sindico',
              description: 'Quer saber se síndico recebe salário? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre síndico!',
              content: `
              <p>Depende do condomínio. De acordo com a legislação brasileira, o pagamento do síndico não é obrigatório. Portanto, é a convenção que decide se o síndico irá receber um salário, assim como o valor pago.</p>
              <p>Para que seja aceito, o pagamento do síndico deve ser discutido e aprovado em uma assembleia geral com os moradores.</p>
              `,
            },
            {
              id: 71,
              title: 'Qual a diferença entre síndico profissional e síndico morador?',
              url: 'qual-a-diferenca-entre-sindico-profissional-e-sindico-morador',
              category: 'sindico',
              description: 'Quer saber qual a diferença entre síndico profissional e síndico morador? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre síndico!',
              content: `
              <p>O síndico profissional é aquele que estuda e se especializa para exercer a função, podendo trabalhar em um ou mais condomínios, mesmo que não more neles.</p>
              <p>Já o síndico morador deve residir no condomínio para poder se candidatar à vaga, além de possuir as habilidades necessárias para cumprir as funções estabelecidas, como paciência, responsabilidade, dedicação e familiaridade com a área de finanças. Costuma se eleger através de votação em assembleia.</p>
              `,
            },
            {
              id: 72,
              title: 'Quem fiscaliza o síndico do condomínio?',
              url: 'quem-fiscaliza-o-sindico-do-condominio',
              category: 'sindico',
              description: 'Quer saber quem fiscaliza o síndico do condomínio? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre síndico!',
              content: `
              <p>De acordo com o código civil, qualquer morador ou moradora pode conferir as contas do condomínio. Também é comum a criação de um Conselho Fiscal, composto por um grupo de moradores responsável por acompanhar e avaliar os deveres do síndico, além de ser uma ponte de contato entre ele e o restante dos moradores.</p>
              <p>Vale ressaltar que a manutenção do conselho fiscal não é obrigatória. Entretanto, caso seja criado, seus representantes devem ser eleitos em uma assembleia.</p>
              `,
            },
            {
              id: 73,
              title: 'O que o síndico não pode fazer?',
              url: 'o-que-o-sindico-nao-pode-fazer',
              category: 'sindico',
              description: 'Quer saber o que o síndico não pode fazer? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre síndico!',
              content: `
              <p>Assim como existem obrigações, existem atividades proibidas, como:</p>
              <ul>
                <li>Esconder ou adulterar atividades realizadas para a prestação de contas;</li>
                <li>Entrar em apartamentos sem consentimento do morador;</li>
                <li>Proibir a entrada de visitas;</li>
                <li>Desobedecer as normas estabelecidas em assembleia;</li>
                <li>Expor informações confidenciais de moradores;</li>
                <li>Ser parcial na tomada de decisões;</li>
                <li>Aprovar grandes obras sem consultar os moradores em uma assembleia.</li>
              </ul>
              `,
            },
          ],
        },
      ],
    },
    {
      iptu: [
        {
          id: 23,
          title: 'Tire suas dúvidas sobre IPTU!',
          image: '/Files/vivaz.com.br/content/img/icons/question.svg',
          questions: [
            {
              id: 74,
              title: 'O que é o IPTU?',
              url: 'o-que-e-o-iptu',
              category: 'iptu',
              description: 'Quer saber o que é o IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>IPTU é a sigla de Imposto Predial e Territorial Urbano. Ele é cobrado de todas as pessoas que possuem uma propriedade urbana, como apartamentos, casas, salas comerciais e todos os tipos de imóveis localizados na área urbana*.</p>
              <small>*Região onde há abastecimento de água, sistema de esgoto, rede elétrica, escolas, hospitais e outros serviços básicos em um raio de até 3 km.</small>
              `,
            },
            {
              id: 75,
              title: 'Quem deve pagar o IPTU?',
              url: 'quem-deve-pagar-o-iptu',
              category: 'iptu',
              description: 'Quer saber quem deve pagar o IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>Toda pessoa que possui um imóvel localizado na área urbana. Entretanto, se a propriedade for alugada, o valor do IPTU pode ser repassado ao inquilino.</p>
              `,
            },
            {
              id: 76,
              title: 'O que acontece se eu não pagar o IPTU?',
              url: 'o-que-acontece-se-eu-nao-pagar-o-iptu',
              category: 'iptu',
              description: 'Quer saber o que acontece se eu não pagar o IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>Caso o IPTU não seja pago em dia, a prefeitura irá cobrar a pessoa responsável pelo imóvel, mesmo que o valor tenha sido repassado em um aluguel. A falta de pagamento pode dificultar a aprovação de empréstimos, financiamentos, cartões e até mesmo vagas de emprego. As principais penalidades são:</p>
              <ul>
                <li>Multa;</li>
                <li>Negativação do CPF;</li>
                <li>Oficialização da dívida em cartório;</li>
                <li>Participação na Dívida Ativa do Município;</li>
                <li>Penhora ou leilão da propriedade.</li>
              </ul>
              `,
            },
            {
              id: 77,
              title: 'Como consultar o IPTU?',
              url: 'como-consultar-o-iptu',
              category: 'iptu',
              description: 'Quer saber como consultar o IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>A consulta do IPTU pode ser feita no site de cada prefeitura ou na Secretaria da Fazenda. Você pode consultar o IPTU pelo CPF  e pelo número de cadastro do imóvel.</p>
              `,
            },
            {
              id: 78,
              title: 'Como emitir a 2ª via do IPTU?',
              url: 'como-emitir-a-2a-via-do-iptu',
              category: 'iptu',
              description: 'Quer saber como emitir a 2ª via do IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>Você pode solicitar a 2ª via do IPTU no site da prefeitura de sua cidade. Caso não haja a opção de emitir o documento online, você deverá comparecer à sede da prefeitura ou Secretaria da Fazenda.</p>
              `,
            },
            {
              id: 79,
              title: 'Como pagar o IPTU?',
              url: 'como-pagar-o-iptu',
              category: 'iptu',
              description: 'Quer saber como pagar o IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>De modo geral, a guia do IPTU funciona igual todos os boletos e pode ser pago em bancos, lotéricas, caixas eletrônicos ou internet banking. Para isso, basta escanear o código de barras ou informar a linha numérica do boleto.</p>
              <p>Além disso, em algumas cidades você poderá cadastrar o pagamento do IPTU por débito automático. Para saber todas as formas de pagamento, entre em contato com a prefeitura de sua cidade.</p>
              `,
            },
            {
              id: 80,
              title: 'Posso pagar o IPTU atrasado?',
              url: 'posso-pagar-o-iptu-atrasado',
              category: 'iptu',
              description: 'Quer saber se pode pagar o IPTU atrasado? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>Pode. Para pagar o IPTU atrasado, você precisa emitir um boleto atualizado do imposto, considerando os juros em cima de cada dia de atraso. Feito isso, basta pagar o boleto pelo método que preferir: bancos, lotéricas, caixas eletrônicos ou internet banking.</p>
              <small>*O débito automático não está disponível para pagamentos atrasados.</small>
              `,
            },
            {
              id: 81,
              title: 'Quem tem direito à isenção do IPTU?',
              url: 'quem-tem-direito-a-isencao-do-iptu',
              category: 'iptu',
              description: 'Quer saber quem tem direito à isenção do IPTU? A Vivaz te ajuda a entender! Acesse nossa página e confira essa e outras dúvidas sobre IPTU!',
              content: `
              <p>No país todo, o IPTU é isento para imóveis do governo, propriedades religiosas, escolas e organizações sem fins lucrativos. Contudo, cada prefeitura pode definir outros tipos de propriedades isentas do imposto na região.</p>
              `,
            },
          ],
        },
      ],
    },
  ],
}



// WEBPACK FOOTER //
// ./src/api/content/faq.js